export { default } from './ExtendedSection';
